import { Formik, FormikValues } from "formik";
import _ from "lodash";
import { FC, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import CreateMeeting from "./MeetingDetailsForm/CreateMeeting";

import { RoutingList } from "../../../../../constants";
import { useCreateMeetingMutation, useUpdateMeetingMutation } from "../../../../../generated/graphql";
import useAppStore from "../../../../../states/zustand/appStore";
import { formikMultiStepHandler } from "../../../../../utils/formikMultiStepFormStepHandler";
import { meetingDetailsSchema, meetingInitalData, meetingScheduleValidationSchema } from "../../utils";

const CreateNewMeetingContainer: FC = (): JSX.Element => {
    const navigate = useNavigate();
    const {id} = useParams() as any;
    const {setLoader} = useAppStore();
    const [createMeeting] = useCreateMeetingMutation();
    const [updateMeeting] = useUpdateMeetingMutation();
    const [steps, setSteps] = useState<number>(0);
    const stepsInfo = useMemo(()=>([
        '1. Meeting Details',
        // '2. Schedule Details',
    ]), [])
       

    const saveHandler = async (values: FormikValues) => {
        try {
            setLoader(true)
            if(id) {
                await updateMeeting({
                    variables:{
                        _id:id,
                        agenda:values.agenda,
                        ...(values.mom !== "" && values.projects.length>0 && { mom:values.mom }),
                        // mom:values.mom,
                        meetingDate: values.meetingDate,
                        lastSubmissionDate: values.lastSubmissionDate,
                        meetingId: values.meetingId,
                        meetingType: values.meetingType,
                        ...(values.mom !== "" && values.projects.length>0 && {projects: values.projects.map((p:any) => ({
                            _id:p._id.value,
                            documents: p.documents.map((d:any) =>({
                                label:d.label,
                                url:d.url
                            }))
                        }))})
                        // projects: values.projects.map((p:any) => ({
                        //     _id:p._id.value,
                        //     documents: p.documents.map((d:any) =>({
                        //         label:d.label,
                        //         url:d.url
                        //     }))
                        // }))
                    }
                })
            }else {
                await createMeeting({
                    variables:{
                        agenda:values.agenda,
                        // mom:values.mom,
                        meetingDate: values.meetingDate,
                        lastSubmissionDate: values.lastSubmissionDate,
                        meetingId: values.meetingId,
                        meetingType: values.meetingType,
                        // projects: values.projects.map((p:any) => ({
                        //     _id:p._id.value,
                        //     documents: p.documents.map((d:any) =>({
                        //         label:d.label,
                        //         url:d.url
                        //     }))
                        // }))
                    }
                })
            }
            navigate(RoutingList.meeting.index.path);
            setLoader(false)     
        } catch (err: any) {
            setLoader(false)     
            toast.error((err as { message: string }).message);
            console.log(err);
        }
    }
   
    return (
        <Formik
        initialValues={_.cloneDeep(meetingInitalData)}
        validationSchema={meetingDetailsSchema}
        onSubmit={(values, { setSubmitting, setErrors, validateForm }) => {
            // saveHandler(values);
            formikMultiStepHandler({
                validateForm,
                values,
                stepIndex:
                steps > stepsInfo.length - 1 ? steps : steps + 1,
                setErrors,
                steps,
                stepsInfo,
                setSteps,
                saveHandler,
              });
        }}
    >
        <CreateMeeting id={id} steps={steps} setSteps={setSteps} stepsInfo={stepsInfo}/>
    </Formik>
    )
}

export default CreateNewMeetingContainer;